export enum InvestorSection {
  Overview = 'Overview',
  HeatGraphs = 'HeatGraphs',
  Trends = 'Trends',
  CurrentSupply = 'CurrentSupply',
  FutureSupply = 'FutureSupply',
  Population = 'Population',
  SimilarNeighbourhoods = 'SimilarNeighbourhoods',
  MatchedListings = 'MatchedListings',
}

export const INVESTORS_NEIGHBOURHOOD_PAGE_SECTIONS: InvestorSection[] = [
  InvestorSection.Overview,
  InvestorSection.HeatGraphs,
  InvestorSection.Trends,
  InvestorSection.CurrentSupply,
  InvestorSection.Population,
  InvestorSection.SimilarNeighbourhoods,
  InvestorSection.MatchedListings,
];

